import React, { useState } from "react";
import StatCardList from "./StatCardList";

export default function StatsPanel() {
    const [lastXDays, setLastXDays] = useState<number | undefined>(undefined);

    return (
        <div className="mt-3 bg-white p-5 rounded w-full">
            <div className="border-b border-gray-200 pb-2">
                <div className="flex items-center justify-between">
                    <h1
                        id="message-heading"
                        className="text-base font-semibold leading-6 text-gray-900">
                        Stats
                    </h1>

                    <select
                        value={lastXDays ?? "all"}
                        onChange={(e) =>
                            setLastXDays(
                                e.target.value === "all" ? undefined : Number(e.target.value)
                            )
                        }
                        className="ml-3 block rounded-md border-gray-300 text-sm focus:border-indigo-500 focus:ring-indigo-500">
                        <option value="7">Last 7 days</option>
                        <option value="30">Last 30 days</option>
                        <option value="all">All time</option>
                    </select>
                </div>
            </div>

            <div className="mt-3">
                <StatCardList lastXDays={lastXDays}/>
            </div>
        </div>
    );
}
